<template>
  <div class="container-fluid page-card adminWeeducCreateVideo">
    <div class="titleContainer myCoursesWeeduc">
      <h3 class="page-title">Nova Atividade Vídeo</h3>
      <p class="page-subtitle">
        Siga os passos para cadastrar seu vídeo.
      </p>
    </div>

    <div class="multistep-container full-width create-video-flow">
      <div
        class="steps-header"
        role="list"
        aria-label="Etapas do cadastro de vídeo"
      >
        <div
          v-for="(step, idx) in steps"
          :key="idx"
          :class="['step-indicator', { active: currentStep === idx + 1, done: currentStep > idx + 1 }]"
          role="listitem"
          :aria-current="currentStep === idx + 1 ? 'step' : undefined"
        >
          <span class="step-number">{{ idx + 1 }}</span>
          <span class="step-label">{{ step }}</span>
        </div>
      </div>

      <div class="steps-content">
        <!-- Passo 1: Origem -->
        <div v-if="currentStep === 1" class="step-panel">
          <div class="video-source-cards step1-options">
            <div
              class="source-card"
              :class="{ selected: videoData.source == 1 || videoData.source == '1' }"
              @click="handleSourceCardClick(1)"
            >
              <div class="icon">
                <fa icon="video" />
              </div>
              <div class="source-title">Videoteca</div>
              <div class="source-desc">
                Use um vídeo já enviado ou faça upload de um novo vídeo diretamente para a plataforma.
              </div>
              <input
                type="radio"
                v-model="videoData.source"
                value="1"
                class="hidden-radio"
              />
            </div>
            <div
              class="source-card"
              :class="{ selected: videoData.source == 2 || videoData.source == '2' }"
              @click="handleSourceCardClick(2)"
            >
              <div class="icon source-card-icon--youtube">
                <fa :icon="['fab', 'youtube']" />
              </div>
              <div class="source-title">YouTube</div>
              <div class="source-desc">
                Insira o link de um vídeo público do YouTube para incorporar ao seu curso.
              </div>
              <input
                type="radio"
                v-model="videoData.source"
                value="2"
                class="hidden-radio"
              />
            </div>
            <div
              class="source-card"
              :class="{ selected: videoData.source == 3 || videoData.source == '3' }"
              @click="handleSourceCardClick(3)"
            >
              <div class="icon source-card-icon--vimeo">
                <fa :icon="['fab', 'vimeo']" />
              </div>
              <div class="source-title">Vimeo</div>
              <div class="source-desc">
                Utilize um vídeo hospedado no Vimeo, basta colar o link do vídeo desejado.
              </div>
              <input
                type="radio"
                v-model="videoData.source"
                value="3"
                class="hidden-radio"
              />
            </div>
          </div>
          <div class="step-actions">
            <button
              class="btn-weflix primary default"
              :disabled="!videoData.source"
              @click="nextStep"
              v-if="currentStep != 1 && currentStep != 3"
            >
              Próximo ({{ currentStep }})  
            </button>
          </div>
        </div>

        <!-- Passo 2: Upload ou Link -->
        <div v-if="currentStep === 2" class="step-panel create-video-step2">
          <header class="create-video-step2__intro">
            <h4 class="create-video-step2__title">Upload de vídeo</h4>
            <p class="create-video-step2__lead subtitle">
              Envie um arquivo novo ou reutilize um vídeo já publicado na videoteca.
            </p>
          </header>

          <!-- Videoteca -->
          <div
            v-if="videoData.source == 1 || videoData.source == '1'"
            class="create-video-step2__segment"
          >
            <div
              class="button-container options-video create-video-step2__actions"
            >
              <button
                type="button"
                class="btn-weflix reuse-video create-video-step2__action-btn"
                @click="openReuseModal"
              >
                <fa icon="sync" />
                <span>Reutilizar vídeo</span>
              </button>
              <button
                type="button"
                class="btn-weflix reuse-video create-video-step2__action-btn create-video-step2__action-btn--secondary"
                @click="showUploadVideo = true"
                v-if="!reuseVideoData.id"
              >
                <fa icon="upload" />
                <span>Upload de arquivo</span>
              </button>
            </div>
            <transition name="fade">
              <div
                class="form-group create-video-step2__dropzone-wrap"
                v-if="showUploadVideo && !reuseVideoData.id"
              >
                <div class="form-file create-video-upload">
                  <div class="file-wrapper primary create-video-step2__dropzone">
                    <label
                      class="thumbnail thumb-img create-video-dropzone__surface"
                      for="weeduc-create-video-upload"
                    >
                      <span class="create-video-dropzone__icon-wrap" aria-hidden="true">
                        <svg
                          class="uploadVideoIcon create-video-dropzone__icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 576 512"
                        >
                          <path
                            d="M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
                          />
                        </svg>
                      </span>
                      <span class="create-video-dropzone__title">Enviar vídeo</span>
                      <span class="create-video-dropzone__hint">
                        Arraste e solte o arquivo aqui ou clique para selecionar
                      </span>
                    </label>
                    <input
                      id="weeduc-create-video-upload"
                      class="form-control create-video-dropzone__input"
                      multiple
                      type="file"
                      @change="uploadVideoAws"
                      accept=".mp4, .avi"
                    />
                  </div>
                  <p class="create-video-dropzone__formats" role="note">
                    Formatos aceitos:
                    <strong>.mp4</strong>
                    e
                    <strong>.avi</strong>
                  </p>
                </div>
                <div
                  class="upload-status"
                  v-if="isUploading || isUploaded"
                >
                  <div
                    class="loading-spinner"
                    v-if="isUploading && !isUploaded"
                  >
                    <fa icon="fa-sync fa-spin" />
                    <span>Enviando vídeo...</span>
                  </div>
                  <div
                    class="upload-complete"
                    v-else-if="isUploaded"
                  >
                    <fa icon="fa-check-circle" />
                    <span>Upload concluído com sucesso!</span>
                  </div>
                  <div
                    class="progress-bar"
                    v-if="isUploading || isUploaded"
                  >
                    <div
                      class="progress-fill"
                      :style="{ width: progress + '%' }"
                    >
                      <span class="progress-text"
                        >{{ Math.round(progress) }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- Exibir informações do vídeo reutilizado -->
            <!-- <div v-if="reuseVideoData.id" class="reused-video-info">
              <div class="video-item">
                <div class="video-player" style="flex: 1;">
                  <iframe
                    :src="videoPlayer"
                    width="100%"
                    height="200"
                    frameborder="0"
                    allow="autoplay; fullscreen"
                    allowfullscreen
                    style="border-radius: 8px;"
                  ></iframe>
                </div>
                <div class="video-info" style="flex: 2; padding-left: 16px;">
                  <h5>{{ reuseVideoData.title }}</h5>
                  <p>{{ reuseVideoData.description }}</p>
                  <button
                    class="btn-weflix default small"
                    @click="clearReuseVideo"
                  >
                    Remover vídeo selecionado
                  </button>
                </div>
              </div>
            </div> -->
          </div>
          <!-- Youtube ou Vimeo -->
          <div
            v-if="videoData.source == 2 || videoData.source == '2' || videoData.source == 3 || videoData.source == '3'"
            class="create-video-step2__segment create-video-step2__segment--link"
          >
            <div class="form-group create-video-step2__link-field">
              <p class="form-label-title create-video-step2__field-label">
                Link do vídeo no
                {{
                  videoData.source == 2 || videoData.source == '2'
                    ? 'Youtube'
                    : videoData.source == 3 || videoData.source == '3'
                    ? 'Vimeo'
                    : 'Videoteca'
                }}
                *
              </p>
              
                <input
                  type="text"
                  class="inputd create-video-step2__url-input"
                  v-model="videoData.youtubeUrl"
                  placeholder="Cole aqui o URL do vídeo"
                  required
                  @input="updateVideoPreview"
                />
            </div>
          </div>

          <footer class="step-actions create-video-step2__footer">
            <button type="button" class="btn-weflix default" @click="prevStep">
              Voltar
            </button>
            <button
              type="button"
              class="btn-weflix primary default"
              :disabled="!canGoToStep3Upload"
              @click="nextStep"
            >
              Próximo
            </button>
          </footer>
        </div>

        <!-- Passo 3: Informações e Preview -->
        <div v-if="currentStep === 3" class="step-panel step-panel-step3">
          <div class="step3-columns">
            <!-- Coluna 1: Formulário -->
            <div class="step3-form-col step3-form-col-60">
              <div class="form-group">
                <label class="labeld required" for="videoTitle">Título</label>
                  <input
                  id="videoTitle"
                    type="text"
                    class="inputd"
                    v-model="videoData.title"
                    placeholder="Escolha um nome que chame a atenção"
                    required
                  />
                  <small>O título é o nome que aparecerá na atividade</small>
                </div>
              <div class="form-group">
                <label class="labeld" for="videoDescription">Descrição</label>
                  <textarea
                  id="videoDescription"
                    class="inputd"
                    v-model="videoData.description"
                    placeholder="Descreva o vídeo"
                    rows="3"
                  ></textarea>
                  <small>A descrição é a descrição que aparecerá na atividade</small>
              </div>
            
            </div>
            <!-- Coluna 2: Preview -->
            <div class="step3-preview-col step3-preview-col-40">
              <div class="preview-container step3-preview" style="height: 100%;">
                <div
                  class="video-preview"
                  v-if="
                    (videoData.youtubeUrl && (videoData.source == 2 || videoData.source == '2' || videoData.source == 3 || videoData.source == '3')) ||
                    (videoData.path && (videoData.source == 1 || videoData.source == '1')) ||
                    (reuseVideoData.id && videoPlayer)
                  "
                  style="height: 100%;"
                >
                  <iframe
                    v-if="videoData.source == 2 || videoData.source == '2'"
                    :src="getYoutubeEmbedUrl(videoData.youtubeUrl)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    style="width: 100%; min-height: 350px; border-radius: 8px;"
                  ></iframe>
                  <iframe
                    v-if="videoData.source == 3 || videoData.source == '3'"
                    :src="getVimeoEmbedUrl(videoData.youtubeUrl)"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                    style="width: 100%; min-height: 350px; border-radius: 8px;"
                  ></iframe>
                  <video
                    v-if="(videoData.source == 1 || videoData.source == '1') && videoData.path && !reuseVideoData.id"
                    controls
                    style="width: 100%; min-height: 350px; border-radius: 8px"
                  >
                    <source :src="videoData.path" type="video/mp4" />
                    Seu navegador não suporta o elemento de vídeo.
                  </video>
                  <!-- Preview para vídeo reutilizado da videoteca -->
                  <iframe
                    v-if="(videoData.source == 1 || videoData.source == '1') && reuseVideoData.id && videoPlayer"
                    :src="videoPlayer"
                    frameborder="0"
                    allow="autoplay; fullscreen"
                    allowfullscreen
                    style="width: 100%; min-height: 350px; border-radius: 8px;"
                  ></iframe>
                </div>
                <div class="video-placeholder" v-else style="display: flex; align-items: center; justify-content: center; height: 100%;">
                  <p>Adicione o vídeo para visualizar a prévia</p>
                </div>
              </div>
              <div class="step-actions" style="margin-top: 24px; justify-content: flex-end;">
                <button
                  class="btn-weflix default"
                  @click="prevStep"
                  style="margin-right: 8px;"
                >
                  Voltar
                </button>
                <button
                  class="btn-weflix default"
                  @click="nextStep"
                  style="margin-right: 8px;"
                  :disabled="currentStep === steps.length"
                  v-if="currentStep != 3"
                >
                  Próximo
                </button>
                <button
                  class="btn-weflix primary default"
                  :disabled="!videoData.title"
                  @click="saveVideo"
                >
                  Salvar vídeo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: reutilizar vídeo da videoteca -->
    <v-dialog v-model="showReuseModal" max-width="720" class="reuse-video-dialog">
      <v-card class="reuse-video-dialog__card" variant="flat">
        <header class="reuse-video-dialog__header">
          <h2 id="reuse-video-dialog-title" class="reuse-video-dialog__title">
            Reutilizar vídeo
          </h2>
          <p class="reuse-video-dialog__lead">
            Escolha um curso e uma atividade para pré-visualizar o vídeo antes
            de confirmar.
          </p>
        </header>

        <div class="reuse-video-dialog__body">
          <div class="reuse-video-dialog__grid">
            <div class="reuse-video-dialog__field">
              <label class="reuse-video-dialog__label" for="reuse-video-course">
                Curso
              </label>
              <select
                id="reuse-video-course"
                v-model="selectedCourse"
                class="form-control reuse-video-dialog__select"
                @change="loadLessons"
                :disabled="loadingLessons"
              >
                <option value="">Selecione um curso</option>
                <option
                  v-for="collection in collections"
                  :key="collection.id"
                  :value="collection.id"
                >
                  {{ collection.name }}
                </option>
              </select>
              <div
                v-if="loadingLessons"
                class="reuse-video-dialog__loading"
                role="status"
                aria-live="polite"
              >
                <fa icon="fa-sync fa-spin" />
                <span>Carregando atividades…</span>
              </div>
            </div>

            <div class="reuse-video-dialog__field">
              <label class="reuse-video-dialog__label" for="reuse-video-lesson">
                Atividade
              </label>
              <select
                id="reuse-video-lesson"
                v-model="selectedLesson"
                class="form-control reuse-video-dialog__select"
                @change="getVideo"
                :disabled="loadingVideo"
              >
                <option value="">Selecione uma atividade</option>
                <option
                  v-for="lesson in listLessons"
                  :key="lesson.id"
                  :value="lesson.id"
                >
                  {{ lesson.name }}
                </option>
              </select>
              <div
                v-if="loadingVideo"
                class="reuse-video-dialog__loading"
                role="status"
                aria-live="polite"
              >
                <fa icon="fa-sync fa-spin" />
                <span>Carregando vídeo…</span>
              </div>
            </div>
          </div>

          <section
            class="reuse-video-dialog__preview"
            aria-labelledby="reuse-video-dialog-title"
          >
            <div v-if="videoInfoCopy.title" class="reuse-video-dialog__preview-inner">
              <div class="reuse-video-dialog__player">
                <iframe
                  :src="videoPlayer"
                  title="Pré-visualização do vídeo selecionado"
                  width="100%"
                  height="280"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                />
              </div>
              <div class="reuse-video-dialog__meta">
                <h3 class="reuse-video-dialog__meta-title">{{ videoInfoCopy.title }}</h3>
                <p
                  v-if="videoInfoCopy.description"
                  class="reuse-video-dialog__meta-desc"
                >
                  {{ videoInfoCopy.description }}
                </p>
              </div>
            </div>
            <div v-else class="reuse-video-dialog__empty">
              <p class="reuse-video-dialog__empty-text">
                Selecione um curso e uma atividade para visualizar o vídeo.
              </p>
            </div>
          </section>
        </div>

        <footer class="reuse-video-dialog__footer">
          <button
            type="button"
            class="reuse-video-dialog__btn reuse-video-dialog__btn--secondary"
            @click="showReuseModal = false"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="reuse-video-dialog__btn reuse-video-dialog__btn--primary"
            :disabled="!videoInfoCopy.title"
            @click="reuseVideo"
          >
            Selecionar vídeo
          </button>
        </footer>
      </v-card>
    </v-dialog>

    <Loader v-if="isSaving" />

  
  </div>
</template>
<script>
import { mapState } from 'vuex';
import apiLesson from '@/utils/lesson';
import Loader from '@/components/Loader/loader.vue';
import Videos from '@/utils/Weflix/videos';
import apiAWS from '@/utils/storage/aws';
import playerVideo from '@/utils/storage/playerVideo';
import { toast } from 'vue3-toastify';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      videoData: {
        source: null,
        path: '',
        title: '',
        description: '',
        youtubeUrl: '',
        token: '',
        uploadId: '',
      },
      showHelp: false,
      isSaving: false,
      isUploading: false,
      isUploaded: false,
      progress: 0,
      tokenVideo: null,
      previewCoverVideo: null,
      coverVideo: null,
      loaderImage: false,
      showReuseModal: false,
      existingVideos: [],
      loading: false,
      loadingLessons: false,
      loadingVideo: false,
      showUploadVideo: false,
      listLessons: [],
      selectedCourse: '',
      selectedLesson: '',
      courses: [],
      collections: [],
      videoInfoCopy: {},
      videoPlayer: '',
      reuseVideoData: {},
      tokenVideoReuse: '',
      currentStep: 1,
      steps: [
        'Origem',
        'Upload/Link',
        'Informações'
      ]
    };
  },
  computed: {
    ...mapState(['token', 'currentCollections', 'currentModule']),
    canGoToStep3() {
      if (this.videoData.source == 1 || this.videoData.source == '1') {
        return !!this.videoData.path || !!this.reuseVideoData.id;
      }
      if (
        this.videoData.source == 2 ||
        this.videoData.source == '2' ||
        this.videoData.source == 3 ||
        this.videoData.source == '3'
      ) {
        return !!this.videoData.youtubeUrl;
      }
      return false;
    },
    canGoToStep3Upload() {
      // Se for upload (videoteca), só habilita se upload finalizado
      if (this.videoData.source == 1 || this.videoData.source == '1') {
        // Se está mostrando upload, só habilita se isUploaded
        if (this.showUploadVideo) {
          return this.isUploaded;
        }
        // Se não está mostrando upload, pode ser reutilizar vídeo, então libera se tem path ou vídeo reutilizado
        return !!this.videoData.path || !!this.reuseVideoData.id;
      }
      // Para YouTube/Vimeo, segue regra normal
      if (
        this.videoData.source == 2 ||
        this.videoData.source == '2' ||
        this.videoData.source == 3 ||
        this.videoData.source == '3'
      ) {
        return !!this.videoData.youtubeUrl;
      }
      return false;
    }
  },
  methods: {
    nextStep() {
      if (this.currentStep < 3) this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    // Novo método para avançar ao próximo passo ao clicar no card
    handleSourceCardClick(source) {
      this.selectSource(source);
      this.nextStep();
    },
    selectSource(source) {
      // Aceita tanto número quanto string
      this.videoData.source = source;
      // Limpa campos ao trocar de origem
      this.videoData.youtubeUrl = '';
      this.videoData.path = '';
      this.showUploadVideo = false;
      this.isUploaded = false;
      this.isUploading = false;
      this.progress = 0;
      // Limpa dados de reutilização
      this.reuseVideoData = {};
      this.videoInfoCopy = {};
      this.videoPlayer = '';
      this.selectedCourse = '';
      this.selectedLesson = '';
    },
    async openReuseModal() {
      this.showReuseModal = true;
      this.loading = true;
    },
    async loadLessons() {
      if (this.selectedCourse) {
        this.loadingLessons = true;
        this.listLessons = [];
        this.selectedLesson = '';
        this.videoInfoCopy = {};
        this.videoPlayer = '';
        
        try {
          const response = await apiLesson.getLeistLessonByCourse(
            this.selectedCourse,
            this.token
          );
          this.listLessons = response;
        } catch (error) {
          toast.error('Erro ao carregar atividades. Por favor, tente novamente.');
          console.error('Erro ao carregar atividades:', error);
        } finally {
          this.loadingLessons = false;
        }
      }
    },
    async selectExistingVideo(video) {},
    toggleHelp() {
      this.showHelp = !this.showHelp;
    },
    getYoutubeEmbedUrl(url) {
      if (!url) return '';
      try {
        const urlObj = new URL(url);
        const videoId = urlObj.searchParams.get('v');

        if (!videoId && urlObj.hostname.includes('youtu.be')) {
          return `https://www.youtube.com/embed/${urlObj.pathname.slice(
            1
          )}`;
        }

        return videoId
          ? `https://www.youtube.com/embed/${videoId}`
          : '';
      } catch (error) {
        toast.error('URL inválida. Por favor, verifique o link e tente novamente.');
        console.error('URL inválida:', error);
        return '';
      }
    },
    getVimeoEmbedUrl(url) {
      const videoId = url.split('/').pop();
      return videoId
        ? `https://player.vimeo.com/video/${videoId}`
        : '';
    },
    updateVideoPreview() {
      this.videoData.path = this.videoData.youtubeUrl;
    },
    async saveVideo() {
      this.isSaving = true;
      
      // Preparar payload baseado no tipo de vídeo
      let payload = {
        idModule: this.currentModule.id,
        title: this.videoData.title,
        description: this.videoData.description,
        videoThumbnail: this.coverVideo,
        sample: 0,
        type: this.videoData.source,
        status: 1,
        lessontime: 0,
      };

      // Se for vídeo reutilizado
      if (this.reuseVideoData.id) {
        payload.token = this.reuseVideoData.token ? [this.reuseVideoData.token] : null;
        payload.uploadId = this.reuseVideoData.uploadId;
        payload.path = this.reuseVideoData.path;
        payload.youtubeUrl = this.reuseVideoData.youtubeUrl;
      } else {
        // Se for novo upload
        payload.token = this.tokenVideo
          ? this.tokenVideo.urls.map((item) => item.token)
          : null;
        payload.uploadId = this.tokenVideo ? this.tokenVideo.uploadId : null;
        payload.path = this.videoData.path;
        payload.youtubeUrl = this.videoData.youtubeUrl;
      }

      try {
        const response = await apiAWS.createVideoVideoteca(
          this.token,
          payload
        );
        this.isSaving = false;
        this.$router.push({ path: '/dashboard/curso', query: { toast: 'Vídeo criado com sucesso!' } });
      } catch (error) {
        toast.error('Erro ao enviar arquivo para AWS. Por favor, tente novamente.');
        console.error('Erro ao enviar arquivo para AWS');
        this.isSaving = false;
      }
    },
    async putFileAws(url, file) {
      try {
        const response = await apiAWS.putFileAWS(url, file);
      } catch (error) {

        console.error('Erro ao enviar arquivo para AWS');
      }
    },
    async updateCoverVideo(event) {
      this.loaderImage = false;
      const file = event.target.files[0];

      const validTypes = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/webp',
      ];
      if (!validTypes.includes(file.type)) {
        alert('Formato de arquivo inválido. Use PNG, JPG ou WEBP.');
        return;
      }

      this.previewCoverVideo = URL.createObjectURL(file);

      try {
        const response = await apiAWS.getSignatureImage(
          this.token,
          file.name
        );
        await this.putFileAws(response.url, file);
        this.coverVideo = response.token;
        this.loaderImage = true;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
        toast.error('Erro na geração do TOKEN AWS. Por favor, tente novamente.');
      }
    },
    async uploadVideoAws(event) {
      try {
        const file = event.target.files[0];

        if (!file) {
          return;
        }

        const fileExtension = file.type.split('/').pop();
        const fileSize = Math.round(file.size / (1024 * 1024));

        if (fileSize > 4096) {
          alert(
            'O arquivo é muito grande. O tamanho máximo permitido é 4GB.'
          );
          return;
        }

        this.videoData.path = URL.createObjectURL(file);

        const CHUNK_SIZE = 4 * 1024 * 1024 * 1024;
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

        const response = await apiAWS.getSignatureVideo(
          this.token,
          totalChunks,
          fileExtension,
          CHUNK_SIZE
        );

        if (!response) {
          throw new Error('URLs de upload inválidas');
        }

        this.tokenVideo = response;

        await this.putVideoAws(
          response.urls,
          file,
          totalChunks,
          CHUNK_SIZE
        );
      } catch (error) {
        console.error('Erro ao enviar arquivo para AWS', error);
        alert(
          'Erro ao fazer upload do vídeo. Por favor, tente novamente.'
        );
        this.isUploading = false;
        this.isUploaded = false;
        this.progress = 0;
      }
    },
    async putVideoAws(urlArray, file, totalChunks, chunkSize) {
      this.isUploading = true;
      this.isUploaded = false;
      let successfulUploads = 0;
      let totalProgress = 0;
      let progressArray = new Array(totalChunks).fill(0);

      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        try {
          await apiAWS.putVideoAWS(
            urlArray[i].url,
            chunk,
            (progress) => {
              progressArray[i] = progress;
              totalProgress =
                progressArray.reduce((a, b) => a + b, 0) /
                totalChunks;
              this.progress = totalProgress;
            }
          );

          successfulUploads++;
          if (successfulUploads === totalChunks) {
            this.isUploaded = true;
            this.isUploading = false;
            this.progress = 100;
          }
        } catch (error) {
          console.error(
            `Erro no upload da parte ${i + 1}:`,
            error
          );
          this.isUploading = false;
          this.isUploaded = false;
          this.progress = 0;
          alert(
            'Erro durante o upload do vídeo. Por favor, tente novamente.'
          );
          throw error;
        }
      }
    },
    async getCollections() {
      try {
        const response = await Videos.listCollections(this.token);
        this.collections = response.map((item) => ({
          id: item.id,
          name: item.name,
          status: item.status,
        }));
      } catch (error) {
        console.error('Erro ao obter coleções:', error);
      }
    },
    async getVideo() {
      if (!this.selectedLesson) {
        this.videoInfoCopy = {};
        this.videoPlayer = '';
        return;
      }

      const param = this.selectedLesson;
      this.loadingVideo = true;
      
      try {
        const response = await Videos.getVideosById(
          this.token,
          param
        );
        console.log('Dados do vídeo carregados:', response);
        this.reuseVideoData = response;
        await this.getPlayerVideo();
        this.videoInfoCopy = response;
      } catch (error) {
        console.error('Erro ao obter dados do video:', error);
        toast.error('Erro ao carregar vídeo. Por favor, tente novamente.');
        this.videoInfoCopy = {};
        this.videoPlayer = '';
      } finally {
        this.loadingVideo = false;
      }
    },
    async getPlayerVideo() {
      if (!this.selectedLesson) return;

      const id = this.selectedLesson;
      try {
        const response = await playerVideo.getPlayerVideo(
          this.token,
          id
        );
        console.log('Player do vídeo carregado:', response);
        this.videoPlayer = response;
        setTimeout(() => {
          this.hasReady = true;
        }, 2000);
      } catch (error) {
        console.error('Erro ao obter o player:', error);
        this.videoPlayer = '';
      }
    },
    reuseVideo() {
      if (!this.reuseVideoData.id) {
        toast.error('Nenhum vídeo selecionado para reutilizar.');
        return;
      }

      this.showReuseModal = false;
      
      // Define os dados do vídeo com base no vídeo reutilizado
      this.videoData.source = this.reuseVideoData.type;
      this.videoData.youtubeUrl = this.reuseVideoData.youtubeUrl || '';
      this.videoData.path = this.reuseVideoData.path || '';
      this.videoData.title = this.reuseVideoData.title || '';
      this.videoData.description = this.reuseVideoData.description || '';
      this.videoData.token = this.reuseVideoData.token || '';
      this.videoData.uploadId = this.reuseVideoData.uploadId || '';
      
      // Reseta flags de upload
      this.showUploadVideo = false;
      this.isUploaded = false;
      this.isUploading = false;
      this.progress = 0;
      
      // Vai direto para o passo 3
      this.currentStep = 3;
      
      console.log('Vídeo reutilizado:', {
        reuseVideoData: this.reuseVideoData,
        videoData: this.videoData,
        videoPlayer: this.videoPlayer
      });
    },
  },

  created() {
    this.getCollections();
  },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/createVideo.css';
</style>
